export interface IGetNodeDebugInfoOptions {
    /** Надо ли включать информацию о дочерних узлах (без рекурсии). */
    children?: boolean;
}

/**
 * Возвращает отладочную информацию об указанном DOM-узле.
 *
 * @param {Node} node
 *      Элемент, для которого надо вернуть информацию.
 * @param {IGetNodeDebugInfoOptions} [options]
 *      Настройки операции.
 * @return {string}
 *      Отладочная информация об указанном элементе.
 */
export function getNodeDebugInfo(node: Node, options?: IGetNodeDebugInfoOptions): string {
    const settings = options || {};
    let info = node.nodeName.toLowerCase();
    // Элементы
    if (node.nodeType === 1) {
        const attrNameList = (node as Element).getAttributeNames();
        const attrInfoList = [];
        let id;
        let className;
        for (let i = 0, len = attrNameList.length; i < len; i++) {
            let attrName = attrNameList[i];
            let attrValue = (node as Element).getAttribute(attrName);
            if (attrName === 'class') {
                className = attrValue;
            } else if (attrName === 'id') {
                id = attrValue;
            } else {
                attrInfoList.push(attrName + '="' + (node as Element).getAttribute(attrName) + '"');
            }
        }
        if (className) {
            attrInfoList.unshift(`class="${className}"`);
        }
        if (id) {
            attrInfoList.unshift(`id="${id}"`);
        }
        if (attrInfoList.length) {
            info += ' ' + attrInfoList.join(' ');
        }
        if (settings.children && node.hasChildNodes()) {
            let children = (node as Element).children.length
                ? (node as Element).children
                : node.childNodes;
            info += '\nchildren:\n';
            for (let i = 0, len = children.length; i < len; i++) {
                info += '    ' + getNodeDebugInfo(children[i], {children: false}) + '\n';
            }
        }
    } else {
        info += '(' + node.nodeType + ')';
    }
    return info;
}
